import { useState, useContext, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { ProjectsContext } from '../../context/ProjectsContext';
import projectsSearch from "../../utils/Search";
import ProjectList from '../ProjectList';

import Header from "../Header";
import Footer from "../Footer";

import { useNavigate } from 'react-router-dom';

export default function Search() {

	const { projects } = useContext(ProjectsContext);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);

	const [searchParams, setSearchParams] = useSearchParams();

	const [foundProjects, setFoundProjects] = useState(false);
	const [searchString, setSearchString] = useState(false);

	const search = async (searchString) => {

		console.log('searchString');
		console.log(searchString);

		let result = projectsSearch(searchString, projects);

		console.log('result');
		console.log(result);
		setFoundProjects(result);
	}
	useEffect(() => {

		let searchString = searchParams.get('q');
		setSearchString(searchString);
		if (searchString && projects.length > 0){
			search(searchString);
		}

    }, [projects, searchParams]);



    return (

		 <div className="page page_projects">

			<Header />

			<main>
				<div className="content">

					<ul className="breadcrumbs">
						<li>
							<a href="/">Home</a>
						</li>
						<li>
							<a href="/">Event</a>
						</li>
						<li>
							<span>Search</span>
						</li>
					</ul>

					<div className="page__title">
						<h1>Search results for  "{searchString}"</h1>

					</div>

					<section>

						<div className="search-page">

							{!foundProjects ?
								<div>
									...Searching...
								</div>

								:

								<ProjectList projects={foundProjects}/>
							}

						</div>

					</section>

				</div>
			</main>

			<Footer />
		</div>
    )
}


